export default {
    equivalences:       { method: 'get',    url: 'equivalences' },
    deleteEquivalence:  { method: 'delete', url: 'equivalences/{id}' },
    storeEquivalence:   { method: 'post',   url: 'equivalences' },
    updateEquivalence:  { method: 'put',    url: 'equivalences/{id}' },
    status:             { method: 'get',    url: 'equivalence_status' },
}